'use client';

import { MarkdownPlugin } from '@platejs/markdown';
import remarkGfm from 'remark-gfm';

import { FieldBlocksKit } from '@/components/editor/plugins/field-blocks-kit';
import { FieldBlockPlaceholderKit } from '@/components/editor/plugins/field-block-placeholder-kit';
import { FieldClearMarksOnBreakKit } from '@/components/editor/plugins/field-clear-marks-on-break-kit';
import { FieldLinkKit } from '@/components/editor/plugins/field-link-kit';
import { FieldListKit } from '@/components/editor/plugins/field-list-kit';
import { FieldMarksKit } from '@/components/editor/plugins/field-marks-kit';
import { FieldMediaKit } from '@/components/editor/plugins/field-media-kit';
import { SlashKit } from '@/components/editor/plugins/slash-kit';

/** Plate plugins for markdown field editors (profile bio, org about, job description). */
export const FieldEditorKit = [
  ...FieldBlocksKit,
  ...FieldBlockPlaceholderKit,
  ...FieldMarksKit,
  ...FieldListKit,
  ...FieldLinkKit,
  ...FieldMediaKit,
  ...SlashKit,
  ...FieldClearMarksOnBreakKit,
  MarkdownPlugin.configure({
    options: {
      remarkPlugins: [remarkGfm],
      // Markdown Guide basic: *italic*, **bold**, - lists, --- rules
      remarkStringifyOptions: {
        emphasis: '*',
        bullet: '-',
        rule: '-',
      },
    },
  }),
];
